import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loading } from "@/components/Kpi";

export function DeleteCategoryDialog({ row, onClose, onDeleted }) {
  const [usage, setUsage] = useState(null);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/categories/${row.category_id}/usage`).then(({ data }) => setUsage(data)).catch((e) => toast.error(errMsg(e))); }, [row.category_id]);
  const confirm = async () => {
    setBusy(true);
    try { const { data } = await api.delete(`/categories/${row.category_id}`, { params: { force: true, reason } }); toast.success(`Voce ${row.code} · ${row.name} eliminata da tutte le operazioni (${data.lines_deleted} righe)`); onDeleted(); onClose(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const blocked = usage && usage.transactions > 0;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-lg" data-testid="delete-category-dialog">
        <DialogHeader><DialogTitle className="font-heading">Eliminare la voce {row.code} · {row.name}?</DialogTitle></DialogHeader>
        {!usage ? <Loading /> : (
          <div className="space-y-3 text-sm">
            <p className="text-red-800 bg-red-50 border border-red-200 rounded p-2" data-testid="delete-category-warning">La voce verrà eliminata <b>da tutte le operazioni</b>, in ogni versione del conto economico (Preventivo, Revisioni, SAL, Finale). L'operazione è tracciata nell'audit log e non è reversibile dall'interfaccia.</p>
            <ul className="text-slate-700 space-y-1" data-testid="delete-category-usage">
              <li>Operazioni coinvolte: <b>{usage.projects.length}</b>{usage.projects.length > 0 && <span className="text-slate-500"> ({usage.projects.map((p) => p.code).join(", ")})</span>}</li>
              <li>Righe di conto economico: <b>{usage.lines}</b> di cui con importo: <b>{usage.lines_with_amount}</b></li>
              <li>Movimenti collegati: <b>{usage.transactions}</b></li>
              {usage.is_system && <li className="text-amber-800">Voce standard del conto economico base: non verrà più proposta nelle nuove operazioni.</li>}
            </ul>
            {blocked && <p className="text-red-800 text-xs" data-testid="delete-category-blocked">Riassegna prima i {usage.transactions} movimenti a un'altra voce (pagina Movimenti).</p>}
            <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2} placeholder="Motivazione (obbligatoria, min 5 caratteri)" className="input-editable w-full text-sm" data-testid="delete-category-reason" />
          </div>
        )}
        <div className="flex justify-end gap-2"><Button variant="outline" onClick={onClose} data-testid="delete-category-cancel">Annulla</Button><Button variant="destructive" onClick={confirm} disabled={busy || !usage || blocked || reason.trim().length < 5} data-testid="delete-category-confirm">Elimina da tutte le operazioni</Button></div>
      </DialogContent>
    </Dialog>
  );
}
